import React from "react"
import Helmet from 'react-helmet';
import { graphql, Link } from "gatsby"
import Layout from "../components/layout"

const toTermPath = value => value.toLowerCase().replace(/\s+/g, "-")

export default function Template({
  data, // this prop will be injected by the GraphQL query below.
}) {
  const { site, markdownRemark } = data // data.markdownRemark holds your post data
  const { siteMetadata } = site
  const { excerpt, frontmatter, html } = markdownRemark
  const description = frontmatter.metaDescription || excerpt
  return (
    <Layout>
      <Helmet>
        <title>{frontmatter.title} | {siteMetadata.title}</title>
        <meta name="description" content={description} />
      </Helmet>
      <div className="blog-post-container">
        <article className="post">
          
          {!frontmatter.thumbnail && (
            <div className="post-thumbnail">
              <h1 className="post-title">{frontmatter.title}</h1>
              <div className="post-meta">{frontmatter.date}</div>
            </div>
          )}
          {!!frontmatter.thumbnail && (
            <div className="post-thumbnail" style={{backgroundImage: `url(${frontmatter.thumbnail})`}}>
              <h1 className="post-title">{frontmatter.title}</h1>
              <div className="post-meta">{frontmatter.date}</div>
            </div>
          )}
          {!!frontmatter.tags && (
            <div className="tag-row -centered">
              {frontmatter.tags.map(tag => (
                <Link className="tag" to={`/tag/${toTermPath(tag)}`} key={tag}>#{tag}</Link>
              ))}
            </div>
          )}
          <div
            className="blog-post-content"
            dangerouslySetInnerHTML={{ __html: html }}
          />
          <div className="post-actions">
            <Link to="/" className="button">Back to posts</Link>
          </div>
        </article>
      </div>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(frontmatter: { path: { eq: $slug } }) {
      html
      excerpt(pruneLength: 160)
      frontmatter {
        date(formatString: "YYYY年MM月DD日")
        path
        title
        thumbnail
        metaDescription
        category
        tags
      }
    }
  }
`
